import React from "react";
import "./about.css";

function About(props) {
	return (
		<main className="main-about">
			{/* ABOUT */}
			<h2 className="h2-about">About</h2>
			<p className="p-about">Soon more</p>

			{/* INFOS */}
			<p className="p-about">
				This Website is build with React and Firebase REST API.
			</p>
			<a className="about-link" href="https://github.com/gael-src/bkz-src">
				Code on GitHub
			</a>
			<p className="p-about">For more information:</p>
			<a className="about-link" href="https://reactjs.org/">
				React doc
			</a>
			<a className="about-link" href="https://firebase.google.com/docs">
				Firebase doc
			</a>
			<a
				className="about-link"
				href="https://firebase.google.com/support/privacy"
			>
				Firebase Privacy
			</a>
			<a className="about-link" href="https://firebase.google.com/docs/rules">
				Firebase Security Rules
			</a>
			<footer className="footer-about">
				{/* IMPRESSUM PRIVACY ARE HOSTED IN A GITHUB REPOSITORY */}
				<a
					className="about-link"
					href="https://github.com/gael-src/bkz-src-impressum-privacy/blob/master/impressum.md"
				>
					Impressum
				</a>
				<a
					className="about-link"
					href="https://github.com/gael-src/bkz-src-impressum-privacy/blob/master/privacy.md"
				>
					Privacy
				</a>
			</footer>
		</main>
	);
}

export default About;
